module.exports = __webpack_public_path__ + "img/couples-054.b9e92985.jpg";